import React, { FC } from "react";
import { CircleLabel } from "../../../../dynamics";
import * as Highcharts from "highcharts";
import { pieLegendToggler } from "../../../../../../crops";
import { EfficiencyElement } from "../../index";
import { formatTime } from "../../../../../../../../utils/format/time";
import st from './EfficiencyChartLegend.module.scss';
import cn from "classnames";
import Legend from "@elements/Legend/Legend";

type EfficiencyChartLegendProps = {
    chartApi: Highcharts.Chart | undefined
    elements: EfficiencyElement[]
}

const EfficiencyChartLegend: FC<EfficiencyChartLegendProps> = (props) => {
    const {
        chartApi,
        elements
    } = props;


    return (
        <Legend
            rowVariant={'nameValue'}
            chartApi={chartApi}
            headersR={[
                <span className={st['legend__header__text']}>Статусы</span>,
                <span className={st['legend__header__text']}>Длительность</span>
            ]}
            rows={elements.map(element => ({
                id: element.id,
                color: element.color,
                values: [
                    <CircleLabel align={'start'} textClassName={cn(st['text'], st['text__status'])} color={element.color} name={element.name}/>,
                    <span className={cn(st['text'], st['text__duration'])}>{formatTime(element.duration)}</span>
                ]
            }))}
            onClick={pieLegendToggler(chartApi)}
        />
    )
}

export default EfficiencyChartLegend